import { all, put, takeEvery, take, spawn, delay, cancelled, cancel, fork, select } from 'redux-saga/effects';
import { createSelector } from 'reselect';
import {downloader, postman} from '../utils/postman';
import downloadFile from "../utils/downloadFile";

const TYPE_API = 'reports';

//*  TYPES  *//

const GET_REPORT_REQUEST = 'GET_REPORT_REQUEST';
const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
const GET_REPORT_ERROR = 'GET_REPORT_ERROR';

const GET_KPI_REPORT_REQUEST = 'GET_KPI_REPORT_REQUEST';
const GET_KPI_REPORT_SUCCESS = 'GET_KPI_REPORT_SUCCESS';
const GET_KPI_REPORT_ERROR = 'GET_KPI_REPORT_ERROR';

const GET_REPORT_BILL_DETAILS_REQUEST = 'GET_REPORT_BILL_DETAILS_REQUEST';
const GET_REPORT_BILL_DETAILS_SUCCESS = 'GET_REPORT_BILL_DETAILS_SUCCESS';
const GET_REPORT_BILL_DETAILS_ERROR = 'GET_REPORT_BILL_DETAILS_ERROR';

const FORM_BILL_DETAILS_REQUEST = 'FORM_BILL_DETAILS_REQUEST';
const FORM_BILL_DETAILS_SUCCESS = 'FORM_BILL_DETAILS_SUCCESS';
const FORM_BILL_DETAILS_ERROR = 'FORM_BILL_DETAILS_ERROR';

const REPORT_EXPORT_TO_EXCEL_REQUEST = 'REPORT_EXPORT_TO_EXCEL_REQUEST';
const REPORT_EXPORT_TO_EXCEL_SUCCESS = 'REPORT_EXPORT_TO_EXCEL_SUCCESS';
const REPORT_EXPORT_TO_EXCEL_ERROR = 'REPORT_EXPORT_TO_EXCEL_ERROR';

const DEFAULT_STATE = 'DEFAULT_STATE';

//*  INITIAL STATE  *//

const initial = {
    data: [],
    columns: [],
    config: [],
    billDetails: [],
    progress: false,
    formProgress: false,
    exportProgress: false,
};

//*  REDUCER  *//

export default (state = initial, { type, payload }) => {
    switch (type) {
        case GET_REPORT_REQUEST:
            return {
                ...state,
                progress: true,
            };
        case GET_REPORT_SUCCESS:
            return {
                ...state,
                progress: false,
                ...payload,
            };
        case GET_REPORT_ERROR:
            return {
                ...state,
                progress: false,
            };
        case GET_KPI_REPORT_REQUEST:
            return {
                ...state,
                progress: true,
            };
        case GET_KPI_REPORT_SUCCESS:
            return {
                ...state,
                progress: false,
                ...payload,
            };
        case GET_KPI_REPORT_ERROR:
            return {
                ...state,
                progress: false,
            };
        case GET_REPORT_BILL_DETAILS_REQUEST:
            return {
                ...state,
                progress: true,
            };
        case GET_REPORT_BILL_DETAILS_SUCCESS:
            return {
                ...state,
                progress: false,
                billDetails: payload,
            };
        case GET_REPORT_BILL_DETAILS_ERROR:
            return {
                ...state,
                progress: false,
            };
        case FORM_BILL_DETAILS_REQUEST:
            return {
                ...state,
                formProgress: true,
            }
        case FORM_BILL_DETAILS_SUCCESS:
        case FORM_BILL_DETAILS_ERROR:
            return {
                ...state,
                formProgress: false,
            }
        case REPORT_EXPORT_TO_EXCEL_REQUEST:
            return {
                ...state,
                exportProgress: true
            };
        case REPORT_EXPORT_TO_EXCEL_SUCCESS:
        case REPORT_EXPORT_TO_EXCEL_ERROR:
            return {
                ...state,
                exportProgress: false
            };
        case DEFAULT_STATE:
            return {
                ...initial
            };
        default:
            return state;
    }
}

//*  ACTION CREATORS  *//

export const getReportRequest = (payload) => {
    return {
        type: GET_REPORT_REQUEST,
        payload
    }
};

export const getKpiReportRequest = (payload) => {
    return {
        type: GET_KPI_REPORT_REQUEST,
        payload
    }
};

export const getReportBillDetailsRequest = (payload) => {
    return {
        type: GET_REPORT_BILL_DETAILS_REQUEST,
        payload
    }
};

export const formBillDetailsRequest = payload => {
    return {
        type: FORM_BILL_DETAILS_REQUEST,
        payload
    }
}

export const reportExportToExcelRequest = payload => {
    return {
        type: REPORT_EXPORT_TO_EXCEL_REQUEST,
        payload
    }
};

//*  SELECTORS *//

const stateSelector = state => state.reports;
export const reportSelector = createSelector(stateSelector, state => state.data);
export const billDetailsSelector = createSelector(stateSelector, state => state.billDetails);
export const columnsSelector = createSelector(stateSelector, state => {
    return state.config.filter(item => state.columns.map(column => column.toLowerCase()).includes(item.name.toLowerCase()))
});

export const progressSelector = createSelector(stateSelector, state => state.progress);
export const formProgressSelector = createSelector(stateSelector, state => state.formProgress);
export const exportProgressSelector = createSelector(stateSelector, state => state.exportProgress);

//*  SAGA  *//

function* getReportSaga({ payload }) {
    try {
        const {type, params} = payload;

        const config = yield postman.get(`/${TYPE_API}/${type}/reportConfiguration`);

        const result = yield postman.post(`/${TYPE_API}/${type}/get`, params);

        yield put({
            type: GET_REPORT_SUCCESS,
            payload: {
                ...result,
                config: config.columns
            }
        })
    } catch (e) {
        yield put({
            type: GET_REPORT_ERROR
        })
    }
}

function* getKpiReportSaga({ payload }) {
    try {
        const {type, params} = payload;

        const config = yield postman.get(`/${TYPE_API}/${type}/reportConfiguration`);

        const result = yield postman.post(`/${TYPE_API}/${type}/get`, params);

        yield put({
            type: GET_KPI_REPORT_SUCCESS,
            payload: {
                columns: config.columns.map(item => item.name),
                config: config.columns,
                data: result.entries,

            }
        })
    } catch (e) {
        yield put({
            type: GET_REPORT_ERROR
        })
    }
}

function* getReportBillDetailsSaga({ payload }) {
    try {
        const {type} = payload;


        const result = yield postman.get(`/${TYPE_API}/${type}/get`);

        yield put({
            type: GET_REPORT_BILL_DETAILS_SUCCESS,
            payload: {
                ...result
            }
        })
    } catch (e) {
        yield put({
            type: GET_REPORT_BILL_DETAILS_ERROR
        })
    }
}

function* formBillDetailsSaga({ payload }) {
    try {
        const {params} = payload;
        console.log(params);
        const result = yield postman.post(`/reports/billDetails/process`, params);
        console.log(result);
        yield put({
            type: FORM_BILL_DETAILS_SUCCESS
        })
    } catch (e) {
        yield put({
            type: FORM_BILL_DETAILS_ERROR
        })
    }
}

function* reportExportToExcelSaga({ payload }) {
    try {
        const {type, params} = payload;

        const result = yield downloader.post(`/${TYPE_API}/${type}/export`, params, { responseType: 'blob' });

        downloadFile(result);

        yield put({type: REPORT_EXPORT_TO_EXCEL_SUCCESS})
    } catch (e) {
        yield put({
            type: REPORT_EXPORT_TO_EXCEL_ERROR
        })
    }
}

export function* saga() {
    yield all([
        takeEvery(GET_REPORT_REQUEST, getReportSaga),
        takeEvery(GET_REPORT_BILL_DETAILS_REQUEST, getReportBillDetailsSaga),
        takeEvery(FORM_BILL_DETAILS_REQUEST, formBillDetailsSaga),
        takeEvery(REPORT_EXPORT_TO_EXCEL_REQUEST, reportExportToExcelSaga),
        takeEvery(GET_KPI_REPORT_REQUEST, getKpiReportSaga),
    ])
}
